import { Segmentnhwb43ukbiy3 as Segment } from './Segment.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SegmentPoolClass;
function SegmentPool() {
  if (SegmentPoolClass === VOID) {
    class $ {
      constructor() {
        this.n3t_1 = 0;
        this.o3t_1 = 0;
      }
      p3t() {
        return Segment().h3t();
      }
      s3t(segment) {
      }
    }
    initMetadataForObject($, 'SegmentPool');
    SegmentPoolClass = $;
  }
  return SegmentPoolClass;
}
var SegmentPool_instance;
function SegmentPool_getInstance() {
  return SegmentPool_instance;
}
//region block: init
SegmentPool_instance = new (SegmentPool())();
//endregion
//region block: exports
export {
  SegmentPool_instance as SegmentPool_instance1ixtbemlc1c8i,
};
//endregion

//# sourceMappingURL=SegmentPool.mjs.map
